import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-warning-calculation-in-progress',
  templateUrl: './warning-calculation-in-progress.component.html',
  styleUrls: ['./warning-calculation-in-progress.component.scss'],
  standalone: false,
})
export class WarningCalculationInProgressComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
  }

}
